/**
 * GB API
 * API for GB Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { EgridMeta } from './egridMeta';
import { HistInfoMeta } from './histInfoMeta';
import { GrundstueckId } from './grundstueckId';
import { CodeEntryMeta } from './codeEntryMeta';
import { GrundstueckListEntryMeta } from './grundstueckListEntryMeta';
import { GrundstueckNummerListEntry } from './grundstueckNummerListEntry';
import { GrundstueckPermissions } from './grundstueckPermissions';


export interface GrundstueckDetailEntryMeta { 
    sdrGeloeschtDatum?: Date;
    mSdrGeloeschtDatum?: FieldMetaData;
    ligArt?: GrundstueckDetailEntryMeta.LigArtEnum;
    mLigArt?: FieldMetaData;
    alpgrundstuecke?: Array<GrundstueckListEntryMeta>;
    mAlpgrundstuecke?: FieldMetaData;
    grundstueckRTFpossible?: boolean;
    mGrundstueckRTFpossible?: FieldMetaData;
    anzahlHaengigeAuftraege?: number;
    mAnzahlHaengigeAuftraege?: FieldMetaData;
    id?: GrundstueckId;
    mId?: FieldMetaData;
    histInfo?: HistInfoMeta;
    mHistInfo?: FieldMetaData;
    eidgenoessischSeit?: string;
    mEidgenoessischSeit?: FieldMetaData;
    anzahlHaengigeGbGeschaefte?: number;
    mAnzahlHaengigeGbGeschaefte?: FieldMetaData;
    grundstueckArt?: GrundstueckDetailEntryMeta.GrundstueckArtEnum;
    mGrundstueckArt?: FieldMetaData;
    grundbuchFuehrung?: GrundstueckDetailEntryMeta.GrundbuchFuehrungEnum;
    mGrundbuchFuehrung?: FieldMetaData;
    isKopie?: boolean;
    mIsKopie?: FieldMetaData;
    flaechenMaessigNichtAusgeschieden?: boolean;
    mFlaechenMaessigNichtAusgeschieden?: FieldMetaData;
    sdrArt?: GrundstueckDetailEntryMeta.SdrArtEnum;
    mSdrArt?: FieldMetaData;
    dokulinkVerfuegbar?: GrundstueckDetailEntryMeta.DokulinkVerfuegbarEnum;
    mDokulinkVerfuegbar?: FieldMetaData;
    egrid?: EgridMeta;
    mEgrid?: FieldMetaData;
    anzahlHaengigeAvGeschaefte?: number;
    mAnzahlHaengigeAvGeschaefte?: FieldMetaData;
    grundstueckPDFpossible?: boolean;
    mGrundstueckPDFpossible?: FieldMetaData;
    permissions?: GrundstueckPermissions;
    mPermissions?: FieldMetaData;
    codeUnterart?: CodeEntryMeta;
    mCodeUnterart?: FieldMetaData;
    grundstueckNummern?: Array<GrundstueckNummerListEntry>;
    mGrundstueckNummern?: FieldMetaData;
}
export namespace GrundstueckDetailEntryMeta {
    export type LigArtEnum = 'STRASSENPARZELLE' | 'CFA' | 'DPI' | 'VEC' | 'VIC' | 'ADG' | 'UEBRIGEART';
    export const LigArtEnum = {
        STRASSENPARZELLE: 'STRASSENPARZELLE' as LigArtEnum,
        CFA: 'CFA' as LigArtEnum,
        DPI: 'DPI' as LigArtEnum,
        VEC: 'VEC' as LigArtEnum,
        VIC: 'VIC' as LigArtEnum,
        ADG: 'ADG' as LigArtEnum,
        UEBRIGEART: 'UEBRIGEART' as LigArtEnum
    };
    export type GrundstueckArtEnum = 'STOCKWERK' | 'LIEGENSCHAFT' | 'MITEIGENTUM' | 'UNBEKANNT' | 'FOLIO' | 'BERGWERK' | 'SDR';
    export const GrundstueckArtEnum = {
        STOCKWERK: 'STOCKWERK' as GrundstueckArtEnum,
        LIEGENSCHAFT: 'LIEGENSCHAFT' as GrundstueckArtEnum,
        MITEIGENTUM: 'MITEIGENTUM' as GrundstueckArtEnum,
        UNBEKANNT: 'UNBEKANNT' as GrundstueckArtEnum,
        FOLIO: 'FOLIO' as GrundstueckArtEnum,
        BERGWERK: 'BERGWERK' as GrundstueckArtEnum,
        SDR: 'SDR' as GrundstueckArtEnum
    };
    export type GrundbuchFuehrungEnum = 'EIDGENOESSISCH' | 'KANTONAL' | 'BEREINIGUNG' | 'EINFUEHRUNG';
    export const GrundbuchFuehrungEnum = {
        EIDGENOESSISCH: 'EIDGENOESSISCH' as GrundbuchFuehrungEnum,
        KANTONAL: 'KANTONAL' as GrundbuchFuehrungEnum,
        BEREINIGUNG: 'BEREINIGUNG' as GrundbuchFuehrungEnum,
        EINFUEHRUNG: 'EINFUEHRUNG' as GrundbuchFuehrungEnum
    };
    export type SdrArtEnum = 'BAURECHT' | 'QUELLENRECHT' | 'KONZESSION' | 'WEITERE';
    export const SdrArtEnum = {
        BAURECHT: 'BAURECHT' as SdrArtEnum,
        QUELLENRECHT: 'QUELLENRECHT' as SdrArtEnum,
        KONZESSION: 'KONZESSION' as SdrArtEnum,
        WEITERE: 'WEITERE' as SdrArtEnum
    };
    export type DokulinkVerfuegbarEnum = 'DOKULINK_VORHANDEN' | 'DOKULINK_NICHT_VORHANDEN';
    export const DokulinkVerfuegbarEnum = {
        VORHANDEN: 'DOKULINK_VORHANDEN' as DokulinkVerfuegbarEnum,
        NICHTVORHANDEN: 'DOKULINK_NICHT_VORHANDEN' as DokulinkVerfuegbarEnum
    };
}


